import React, { useState } from 'react';
import ReactTable from "react-table";
import treeTableHOC from "react-table/lib/hoc/treeTable";
import {
  Card,
  CardBody,
  CardTitle,
  Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Row, Col,
  ButtonGroup,
} from 'reactstrap';
import "react-table/react-table.css";
import * as data from "../tables/reactable-data";
import Switch from "react-switch";
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import avatar from '../../assets/images/users/3.jpg'
import Select, { components } from 'react-select'
import countryList from 'react-select-country-list'
// import { SelectTimezone } from 'react-select-timezone';
import { baseURL, baseImgURL } from '../../Api/BaseApi';
import { auth } from '../../Api'
import ImageUploader from 'react-images-upload';
import { getName } from 'country-list';
import TimeZoneField from '../../components/people/timeZoneField'
import LocalPhoneField from '../../components/people/localPhoneField'
import { dialCodeFor, toInternational, phoneProblem } from '../../utils/phone'
import { MAX_FIELD_LENGTH, isFieldTooLong } from '../../utils/fieldLimits'
import { formatServerMessage } from '../../utils/serverErrors'
import { leaveForm } from '../../utils/formReturn'
import { rememberAccount, PRIVATE } from '../../utils/accountType'
import EditButtons, { markChanged } from '../../components/forms/editButtons'
import { formatPhone } from '../../utils/phone'

// The Private owner's CID for the Mobiliis app, on "Your details" (and in the welcome email)
export function ownerCidLines(cid) {
  return cid ? ['Your CID for the Mobiliis app: ' + cid, 'You only need it if the app asks for it: you sign in with your phone number.'] : []
}

export function CountryFlag(props) {
  return (
    <span
      className={"flag-icon flag-icon-" + props.code}
      style={{ fontSize: props.size || "30px" }}
    />
  );
}

export const CountryFlagSelectOption = props => {
  return (
    <components.Option {...props}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <CountryFlag size={props.flagSize} code={props.value.toLowerCase()} />
        {props.label}
      </div>
    </components.Option>
  );
};

export const CountryFlagValueContainer = ({ children, ...props }) => {
  const code = (props.hasValue && props.getValue()[0].value) || false;

  return (
    <div style={{ display: "flex", flexGrow: 1 }}>
      {(code && <CountryFlag code={code.toLowerCase()} />) || null}
      <components.ValueContainer {...props}>
        {children}
      </components.ValueContainer>
    </div>
  );
};

const styles = {
  valueContainer: (base, state) => {
    const height = "35px";
    return { ...base, height };
  }
};

class CompanyEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      open: false,
      modal: false,
      showAlert: false,
      showResult: false,
      alertMessage: '',
      obj: {},
      jsonData: data.dataTable,
      data: data.makeData(),
      treedata: data.treedata,
      options: countryList().getData(),
      nameValue: "",
      emailValue: "",
      phoneValue: "",
      timeValue: '',
      countryValue: "",
      password: '',
      avatarUrl: '/storage/avatar.jpg',
      companyData: {},
      center: {
        lat: 59.95,
        lng: 30.33
      },
      pictures: [],
      showAlert: false,
      showResult: false,
      zoom: 11,
      verify:true,
      // The Contact Person, first and last name in two fields (invoices: "Attn: <full name>"; emails: "Dear <first name>")
      contactFirstName: '',
      contactLastName: ''
    };
    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }

  // In the Account page (no page of its own): it opens read-only with an Edit button, and goes back to read-only after
  // Save and exit or Discard changes. As its own page (/company-edit): the form at once, left with the buttons.
  inAccountPage() {
    return !this.props.history
  }

  componentDidMount() {
    this.setState({ editing: !this.inAccountPage() })
    this.loadCompany()
  }

  loadCompany() {
    let companyId = localStorage.getItem('companyId')
    let admin_id = localStorage.getItem('admin_id')
		this.setState({
      admin_level : localStorage.getItem('admin_level')
    })
    console.log("companyId:", companyId)
    this.setState({
      companyId: companyId,
      admin_id: admin_id
    })
    if (companyId != null) {
      var req = {}
      req.id = companyId
      auth.getCompany(req)
        .then((res) => {
          if (res.data.code == 200) {
            let timeValue = ""
            let companyData = res.data.message.users[0];
            console.log("compmnayData:", companyData)
            timeValue = { value: companyData.timezone, label: companyData.timezone }
            // A Private account: "Your details" (the person's first and last name, no company name; utils/accountType.js)
            const account = res.data.message.account || null
            if (account) {
              rememberAccount(account)
            }
            this.setState({
              isPrivate: !!account && account.account_type === PRIVATE,
              ownerCid: account ? account.owner_cid || null : null,
              password: '',
              formChanged: false,
              contactFirstName: companyData.contact_first_name || '',
              contactLastName: companyData.contact_last_name || '',
              nameValue: companyData.name,
              emailValue: companyData.email,
              phoneValue: companyData.phonenumber,
              avatarUrl: companyData.avatar,
              countryValue: {
                value: companyData.countrycode,
                label: getName(companyData.countrycode)
              },
              timeValue: timeValue,
              companyData: companyData,
              verify: companyData.email_verified_at!=null?true:false
              // locationData:res.data.message.locations
            })
          }
        });
    }
  }

  toggle() {
    this.setState({
      showAlert: !this.state.showAlert
    });
  }
  changeCountry = value => {
    console.log("countryvalue:", value)
    this.setState({ countryValue: value });
    markChanged(this)()
  };

  // Exit edit page / Discard changes: nothing saved. In the Account page: the saved details again, read-only;
  // otherwise back where the form was opened from
  exitEdit = () => {
    if (this.inAccountPage()) {
      this.setState({ editing: false, savedNote: '' })
      this.loadCompany()
      return
    }
    const companyId = this.state.companyId
    leaveForm(this.props.history, companyId != null ? '/company/company-view/' + companyId : '/companies')
  }
  changeTimezone = value => {
    this.setState({ timeValue: value });
  }
  onSave = (event) => {

    let { emailValue, phoneValue, countryValue, timeValue, nameValue,
      password, avatarUrl, companyId, admin_id, companyData,verify,
      contactFirstName, contactLastName } = this.state
    this.setState({ showResult: false });
    var req = {}
    let alertMessage = "";
    const isPrivate = this.state.isPrivate === true
    if (isPrivate && (!contactFirstName || !contactFirstName.trim() || !contactLastName || !contactLastName.trim())) {
      this.setState({ showAlert: true, showResult: false, alertMessage: 'Please enter your first and last name.' })
      return
    }
    if (!isPrivate && (!nameValue || nameValue.trim() === '')) {
      alertMessage = 'Please enter a Company Name.\n'
      this.setState({
        showAlert: true,
        showResult: false,
        alertMessage: alertMessage
      })
      return
    }
    if (!isPrivate && isFieldTooLong(nameValue)) {
      alertMessage = 'Company Name must be ' + MAX_FIELD_LENGTH + ' characters or fewer.\n'
      this.setState({
        showAlert: true,
        showResult: false,
        alertMessage: alertMessage
      })
      return
    }
    if (isFieldTooLong(contactFirstName) || isFieldTooLong(contactLastName)) {
      this.setState({ showAlert: true, showResult: false,
        alertMessage: 'The contact first and last name must each be ' + MAX_FIELD_LENGTH + ' characters or fewer.\n' })
      return
    }
    if (!emailValue || emailValue.trim() === '') {
      alertMessage = 'Please enter an Email.\n'
      this.setState({
        showAlert: true,
        showResult: false,
        alertMessage: alertMessage
      })
      return
    }
    if (!countryValue || !countryValue.value) {
      alertMessage = 'Please select a Country.\n'
      this.setState({
        showAlert: true,
        showResult: false,
        alertMessage: alertMessage
      })
      return
    }
    if (!timeValue || !timeValue.value) {
      alertMessage = 'Please choose the time zone: the country has several.\n'
      this.setState({
        showAlert: true,
        showResult: false,
        alertMessage: alertMessage
      })
      return
    }
    // A new company has no password yet, so one must be entered (server requires at least 6 characters)
    if (companyId == null && (!password || password.length < 6)) {
      alertMessage = 'Please enter a Password of at least 6 characters.\n'
      this.setState({
        showAlert: true,
        showResult: false,
        alertMessage: alertMessage
      })
      return
    }
    // The local number completed with the country's dialling code; the server does the same
    const dialCode = dialCodeFor(countryValue.value)
    if (phoneValue && String(phoneValue).trim() !== '') {
      const phonenumber = toInternational(phoneValue, dialCode)
      if (!phonenumber) {
        this.setState({ showAlert: true, showResult: false, alertMessage: phoneProblem(phoneValue, dialCode) })
        return
      }
      req.phonenumber = phonenumber
    } else {
      this.setState({ showAlert: true, showResult: false, alertMessage: 'Please enter a Phone number.\n' })
      return
    }
    req.admin_id = admin_id
    // A Private account's name is the person's full name: the server makes it from the first and last name
    if (!isPrivate) {
      req.name = nameValue
    }
    req.email = emailValue
    req.timezone = timeValue.value
    // On edit, a blank password means "keep the current one", so only send it when typed
    if (password) {
      req.password = password
      req.password_confirmation = password
    }
    req.avatar = avatarUrl
    req.countrycode = countryValue.value
    req.level = "c"
    req.verify = verify
    req.contact_first_name = contactFirstName ? contactFirstName.trim() : ''
    req.contact_last_name = contactLastName ? contactLastName.trim() : ''
    let that = this;
    console.log("companyID:",companyId)
    if (companyId != null) {
      req.id = companyId
      req.admin_id = companyData.admin_id
      auth.updateCompany(req)
        .then((res) => {
          console.log("res:", res);
          if (Number(res.data.code) === 200 && that.props.history) {
            // Back to the page the form was opened from, or the company's page
            leaveForm(that.props.history, '/company/company-view/' + companyId)
          }
          else if (Number(res.data.code) === 200) {
            // Inside the Account page (no page of its own to leave): back to the details, read-only, as saved
            that.setState({ editing: false, savedNote: 'Your changes were saved.' })
            that.loadCompany()
          }
          else {
            that.setState({
              showAlert: true,
              showResult: false,
              alertMessage: formatServerMessage(res.data.message, 'Update failed. Please try again.')
            })
          }
        })
        .catch(() => {
          that.setState({
            showAlert: true,
            showResult: false,
            alertMessage: 'Could not reach the server. Please try again.'
          })
        })
    }
    else auth.register(req)
      .then((res) => {
        console.log("auth.register's res:", res);
        if (res.data.message != null) {
          if (res.data.code == 400) {
            console.log("res.data.message.email:", res.data.message.email, res.data.message.email != null);
            if (res.data.message.email != null) {
              alertMessage += 'The email already exists.\n'
            }
            if (res.data.message.phonenumber != null) {
              alertMessage += 'This phone number already exists\n'
            }
            if (res.data.message.countrycode != null) {
              alertMessage += "Please select country\n"
            }
            if (alertMessage === '') {
              alertMessage = formatServerMessage(res.data.message, 'Could not create the company. Please check the form.')
            }
            console.log(["res.data.message:", res.data.message, alertMessage]);
            that.setState({
              showAlert: true,
              showResult: false,
              alertMessage: alertMessage
            })
            console.log(["res.data.message:", alertMessage, that.state.alertMessage]);
          }
          else if (Number(res.data.code) === 201 && that.props.history) {
            // Back to the page the form was opened from, or the companies list (the company page shows the
            // company open in the admin website, which a new company is not yet)
            leaveForm(that.props.history, '/companies')
          }
          else if (res.data.code == 201) {
            alertMessage = 'Created Successfully'
            that.setState({
              showAlert: true,
              showResult: true,
              alertMessage: alertMessage
            })
          }
        }
      });
  }
  handleChange = (event) => {
    console.log(["event.valu:", event.target.value, event.target.name])
    switch (event.target.name) {
      case "name":
        this.setState({
          nameValue: event.target.value
        })
        break;
      case "email":
        this.setState({
          emailValue: event.target.value
        })
        break;
      case "phone":
        this.setState({
          phoneValue: event.target.value
        })
        break;
      case "password":
        this.setState({
          password: event.target.value
        })
        break;
      case "contact_first_name":
        this.setState({ contactFirstName: event.target.value })
        break;
      case "contact_last_name":
        this.setState({ contactLastName: event.target.value })
        break;
    }
  }

  setPhoneNumber = (event) => {
    console.log("event of phone:", event)
    this.setState({
      phoneValue: event
    })
    markChanged(this)()
  }

  setEmailVerify = (event) => {
    console.log("event of verify:", event)
    this.setState({
      verify:event
    })
    markChanged(this)()
  }

  onDrop(picture) {
    let { pictures } = this.state
    pictures = []
    var req = {}
    req.file = picture[0]
    console.log("req:", req);
    var that = this;

    auth.upload(req)
      .then((res) => {
        if (res.data.code == 201) {
          var avatarL = res.data.url.split("/")
          that.setState({
            avatarUrl: avatarL[avatarL.length - 1]
          })
        }
      })
    this.setState({
      pictures: this.state.pictures.concat(picture),
    });
    markChanged(this)()
  }

  // The Account page's first tab before Edit: the details as text
  renderDetails() {
    const { isPrivate, countryValue } = this.state
    const line = (label, value) => (
      <Row className="company-text-area" key={label}>
        <div className="col-md-3 control-label">{label}</div>
        <div className="col-md-9 details-value">{value || '-'}</div>
      </Row>
    )
    return (
      <div className="col-md-7">
        {!isPrivate && line('Company Name', this.state.nameValue)}
        {line(isPrivate ? 'First name' : 'Contact first name', this.state.contactFirstName)}
        {line(isPrivate ? 'Last name' : 'Contact last name', this.state.contactLastName)}
        {line('Email', this.state.emailValue)}
        {line('Country', countryValue && countryValue.label)}
        {line('Phone', formatPhone(this.state.phoneValue))}
        {this.state.savedNote ? <p className="saved-note">{this.state.savedNote}</p> : null}
      </div>
    )
  }

  render() {
    let { avatarUrl, companyId, isPrivate, editing } = this.state
    const title = !isPrivate ? 'Company Information' : this.state.admin_level === 'c' ? 'Your details' : 'Account details (private account)'
    const cidLines = isPrivate ? ownerCidLines(this.state.ownerCid) : []
    return <div>
      <Card>
        <Row className="toolbar up-card-title">
          <div className="b-title"><i className="mr-2 mdi mdi-account-multiple-outline mr-10"></i>&nbsp;{title}</div>
          {/* The Account page's details open read-only */}
          {editing === false && <Button color="primary" className="title-edit-button" onClick={() => this.setState({ editing: true, formChanged: false, savedNote: '' })}>
            <i className="mdi mdi-lead-pencil"></i> Edit</Button>}
        </Row>
        {cidLines.length > 0 && <div className="owner-cid">
          <strong>{cidLines[0]}</strong>
          <div>{cidLines[1]}</div>
        </div>}
        <Row className="toolbar up-card-box justify-content-center">
          <div className="col-md-3" style={{ textAlign: "center" }}>
            <img src={avatarUrl != "" ? avatarUrl == "/storage/avatar.jpg" ? avatar : baseImgURL + avatarUrl : avatar} className="img-company"></img>
            {editing && <Form>
              <FormGroup>
                {/* <Input type="file" name="file" id="exampleFile" onChange={this.onDrop} /> */}
                <ImageUploader
                  withIcon={false}
                  buttonText='Choose images'
                  onChange={this.onDrop}
                  accept='image/jpeg,image/png'
                  imgExtension={['.jpg', '.jpeg', '.png']}
                  maxFileSize={204800}
                  label='Max file size: 200KB, max dimensions: 360x360px, accepted: jpg, png'
                  singleImage={true}
                />
              </FormGroup>
            </Form>}
          </div>
          {!editing ? this.renderDetails() : <form className="col-md-7" onSubmit={(event) => { event.preventDefault(); this.onSave() }} onChangeCapture={markChanged(this)}>
            {/* A Private account has no company name: its name is the person's full name */}
            {!isPrivate && <Row className="company-text-area">
              <label className="col-md-3 control-label">Company Name</label>
              <div className="col-md-9">
                <input className="location-text-input" name="name" type="text" value={this.state.nameValue} onChange={this.handleChange} required></input>
              </div>
            </Row>}
            {/* The person invoices are addressed to: "Attn: <full name>" on them, "Dear <first name>" in the emails (a
                Private account: the person themselves) */}
            <Row className="company-text-area">
              <label className="col-md-3 control-label">{isPrivate ? 'First name' : 'Contact first name'}</label>
              <div className="col-md-9">
                <input className="location-text-input" name="contact_first_name" type="text" value={this.state.contactFirstName} onChange={this.handleChange}
                  placeholder={isPrivate ? '' : 'First name of the person invoices are addressed to'} required={isPrivate}></input>
              </div>
            </Row>
            <Row className="company-text-area">
              <label className="col-md-3 control-label">{isPrivate ? 'Last name' : 'Contact last name'}</label>
              <div className="col-md-9">
                <input className="location-text-input" name="contact_last_name" type="text" value={this.state.contactLastName} onChange={this.handleChange}
                  placeholder={isPrivate ? '' : 'Last name'} required={isPrivate}></input>
              </div>
            </Row>
            <Row className="company-text-area">
              <label className="col-md-3 control-label">Email</label>
              <div className="col-md-9">
                <input className="location-text-input" name="email" type="text" value={this.state.emailValue} onChange={this.handleChange} required></input>
              </div>
            </Row>
            <Row className="company-text-area">
              <label className="col-md-3 control-label">Country</label>
              <div className="col-md-9">
                <Select
                  styles={styles}
                  components={{ Option: CountryFlagSelectOption, ValueContainer: CountryFlagValueContainer }}
                  options={this.state.options}
                  value={this.state.countryValue}
                  onChange={this.changeCountry}
                />
              </div>
            </Row>
            <Row className="company-text-area">
              <label className="col-md-3 control-label">Phone</label>
              <div className="col-md-9">
                {/* The country's dialling code as a fixed label, then the local number */}
                <LocalPhoneField
                  dialCode={dialCodeFor(this.state.countryValue ? this.state.countryValue.value : null)}
                  value={this.state.phoneValue}
                  onChange={this.setPhoneNumber}
                  required />
              </div>
            </Row>
            {/* Only when the country has several time zones; otherwise set from the country without a word */}
            <TimeZoneField row
              country={this.state.countryValue ? this.state.countryValue.value : null}
              value={this.state.timeValue ? this.state.timeValue.value : null}
              onChange={(zone) => this.setState({ timeValue: zone ? { value: zone, label: zone } : '' })}
            />
            <Row className="company-text-area">
              <label className="col-md-3 control-label">Password</label>
              <div className="col-md-9">
                <input className="location-text-input" name="password" type="text" value={this.state.password} onChange={this.handleChange}
                  placeholder={companyId != null ? 'Leave blank to keep the current password' : 'At least 6 characters'}
                  required={companyId == null}></input>
              </div>
            </Row>
            {this.state.admin_level!='a'?<></>:<Row className="company-text-area">
              <label htmlFor="email_verify" className="col-md-3 control-label">Email Verified</label>
              <div className="col-md-9">
                <Switch onChange={(value) => this.setEmailVerify(value)} uncheckedIcon checkedIcon offColor="#ddd"
                  checked={this.state.verify}
                />
              </div>
            </Row>}
            {/* The price per duty start and the billing start date are on the super admin's Billing page */}
            <div className="height-10"></div>
            <EditButtons changed={this.state.formChanged} onExit={this.exitEdit} />
            <div className="height-10"></div>
          </form>}
        </Row>
      </Card>
      <Modal isOpen={this.state.showAlert} toggle={this.toggle}>
        {/* <ModalHeader toggle={this.alertToggle}>Alert Modal</ModalHeader> */}
        <ModalBody className="alert-body">
          <i className="mdi mdi-alert-circle ft-60"></i>
          <h2>{this.state.alertMessage}</h2>
          <div className="height-10"></div>
          <FormGroup>
            <Button color="secondary" style={{ width: '100px' }} className="ml-1" onClick={this.toggle}>Cancel</Button>
            <span>&nbsp;&nbsp;</span>
            <Button color="primary" style={{ width: '100px' }} onClick={this.toggle}>Ok</Button>
          </FormGroup>
        </ModalBody>
      </Modal>
    </div>
  }
}


export default CompanyEdit;
